export type ChipChoice = {
  value: string;
  label: string;
  avatar_url?: string;
  color?: string;
  detail?: string;
};

const ENTRY_SEPARATOR = /[,;\n]/;

// Pasted text can hold several entries at once
export const typedEntries = (draft: string): string[] =>
  draft
    .split(ENTRY_SEPARATOR)
    .map((entry) => entry.trim())
    .filter(Boolean);

export function addEntries(entries: string[], additions: string[]): string[] {
  const next = [...entries];
  for (const addition of additions) {
    if (!next.includes(addition)) next.push(addition);
  }
  return next;
}

const MAX_MATCHES = 6;

// The first few choices not yet in the list whose label, value or detail holds the query
export function matchChoices(
  choices: ChipChoice[],
  query: string,
  chosen: string[]
): ChipChoice[] {
  const needle = query.trim().toLowerCase();
  return choices
    .filter(
      (choice) =>
        !chosen.includes(choice.value) &&
        [choice.label, choice.value, choice.detail ?? ''].some((text) =>
          text.toLowerCase().includes(needle)
        )
    )
    .slice(0, MAX_MATCHES);
}

export const suggestionId = (listId: string, index: number): string =>
  `${listId}-option-${index}`;
